<template>
    <b-modal
        cancel-title="Abbrechen"
        modal-class="email-set-reminder-modal info-card editMode"
        :ok-disabled="!dateValue"
        ok-title="Speichern"
        size="md"
        title="Wiedervorlagedatum setzen"
        :visible="show"
        @hidden="$emit('cancel')"
        @ok.prevent="onConfirm">
        <b-form-group
            class="info-card-element"
            label="Wiedervorlagedatum"
            label-for="reminder-date-input">
            <csp-datepicker
                id="reminder-date-input"
                v-model="dateValue"
                :min-date="tomorrowString"/>
        </b-form-group>
    </b-modal>
</template>

<script>
import DatePicker from '@components/form/Datepicker';

export default {
    name: 'EmailSetReminderModal',
    components: {
        'csp-datepicker': DatePicker,
    },
    props: {
        show: {
            required: true,
            type: Boolean,
        },
    },
    emits: ['cancel', 'confirm'],
    data() {
        return {
            dateValue: null,
        };
    },
    computed: {
        tomorrowString() {
            // TODO: keep in computed for page that is opened over-night?
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return tomorrow.toISOString().slice(0, 10);
        },
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.dateValue = null;
            }
        },
    },
    methods: {
        onConfirm() {
            if (!this.dateValue) {
                return;
            }
            this.$emit('confirm', this.dateValue);
        },
    },
};
</script>
